import React, { useEffect, useState, useLayoutEffect } from 'react'
import { useMemo } from 'react';
import Cookie from 'react-cookies';
import { Spinner } from 'react-bootstrap';
// import { createNews } from '../api/admin-api';
import { DeleteForever } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { getAbout, newSlide, updateAbout } from '../../api/api';
import { useSelector } from 'react-redux';
const UPdateAbout = () => {

  const [loading, setLoading] = useState(false);
  const oldData = useSelector(state => state.about.about);
  const [data, setData] = useState(oldData);
  const [newsImages, setNewsImages] = useState([oldData.img]); 
  
  const handleInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setData({
      ...data, [name]: value
    })
  }
  const handleSubmit = async (e) => {

    e.preventDefault()
    let formId = document.getElementById('createNewsForm');
    const formData = new FormData(formId);
    formData.append('id', data.id);
    formData.delete('file []');
    newsImages.forEach((value, key, data) => {
      if(typeof(value) === 'object'){
          formData.append('file []', value);
          formData.append('imageStatus', true);
      }else{
        formData.append('imageStatus', false);
      }
  })
    console.log(formData);
	const res = await updateAbout(formData);
      console.log(res);
      if(res.success){
        Swal.fire({
			title: "Successful",
			text: res.message,
			// timer: 3000,
			icon: 'success',
			confirmButtonColor: '#320808'
		})
        getAbout();
        // e.target.reset();
		// setNewsImages([]);
      }else{
        Swal.fire({
			title: "Failed",
			text: res.message,
			// timer: 3000,
			icon: 'error',
			confirmButtonColor: '#320808'
		})
      }
    
  } 
  
  
  useEffect(() => {
    getAbout();
    document.title = 'About BSC | Bida Sport Club'
  }, [])
  useEffect(() => {
    setData(oldData);
    setNewsImages([oldData.img])
  }, [oldData])
  return (
    <div className='d-flex justify-content-center align-items-center'
    style={{ 
      backgroundColor: 'whitesmoke'
     }}
    >
      <div className=' container card my-5 mx-4 px-4 '
      
      >
          <div className="">
            <p className="small-header ms-4 mt-4"> Update About BSC </p>
            
        <form method='POST' onSubmit={handleSubmit}
        id="createNewsForm"
        >
          <div className="row mb-4">
            <div className="col-12">
                <div className="card mb-4">
                    <div className="card-body">
                    
                        <div className='d-flex justify-content-center align-items-center'>
                        {
                            newsImages.length === 0 && 
                            <div>
                                <input type="file"  
                                onChange={(e) => {
                                    console.log(e.target.files)
                                    // let media = [...newsImages.media,...e.target.files]
                                setNewsImages([...newsImages,...e.target.files])
                                    // dispatch(addProduct({media}))
                                }}
                                style={{display:"none"}} placeholder="Type here" name='file []' multiple className="form-control" id="uploadImages"
                                />
                                <label  htmlFor='uploadImages' className='upload-images-label d-flex justify-content-center align-items-center' style={{
                                        display: "block",
                                        width: "200px",
                                        height:100,
                                        borderStyle:'dashed',
                                        borderColor:'GrayText',
                                        borderWidth:0.5,
                                        borderRadius:5,
                                    }
                                }>
                                    <span style={{fontSize:16}} className='text-center'> Click to Add Image</span>
                                </label>
                            </div>
                        }
                        {
                            newsImages.length !== 0 &&
                            <div className='products-container d-flex justify-content-start align-items-center m-2'>
                            {
                                newsImages && newsImages.map(function(img,index){
                                    return (
                                        <div  key= {index} className='product-container d-flex-column mx-2 justify-content-center align-items-center' style={{
                                            cursor: "pointer",
                                            borderRadius:5,
                                            borderWidth:1,
                                            borderColor:"#e0e2e3",
                                }} >
                                        <img
                                            src={ typeof(img) === 'object' ? URL.createObjectURL(img) : img}
                                            alt={index+"product_image"}
                                            width={200}
                                            height={120}
                                        />
                                        {/* <div className='delete-product d-flex justify-content-center align-items-center' style={{color:'#a50f0f'}} onClick={()=>{
                                            setNewsImages(newsImages.filter((_,ind)=> ind != index))
                                        }}>
                                            <i className="material-icons md-delete_forever"></i>
                                        </div> */}
                                        <DeleteForever
                                        className='d-flex justify-content-center align-self-center justify-contents-center'
                                        color='error'
                                        onClick={() => setNewsImages(newsImages.filter((_,ind)=> ind != index))}
                                        />
                                </div>
                                    )
                                })
                            }
                        </div>
                        }
                        </div>
                        
                      <small className='text-danger' style={{ 
                        fontSize: 12
                       }}> <b>Note: Not more than one image. </b> </small> 
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className=" mx-4">
                    <div className="form-group my-1">
                        <label className="text-muted news-title"> Image Title </label>
                        <input 
                        id='image_title'
                        name='image_title'
                        onChange={handleInput}
                        value={data.image_title}
                        className="form-control form-control-md" type={'text'} placeholder='Enter Club Name' required />
                    </div>
                </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6">
                <div className=" mx-4">
                    <div className="form-group my-1">
                        <label className="text-muted news-title"> Club Name </label>
                        <input 
                        id='club'
                        name='club'
                        value={data.club}
                        onChange={handleInput}
                        className="form-control form-control-md" type={'text'} placeholder='Enter Club Name' required />
                    </div>
                </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6">
                <div className=" mx-4">
                    <div className="form-group my-1">
                        <label className="text-muted news-title"> Club Moto </label>
                        <input 
                        id='moto'
                        name='moto'
                        value={data.moto}
                        onChange={handleInput}
                        className="form-control form-control-md" type={'text'} placeholder='Enter Club Moto' required />
                    </div>
                </div>
            </div>
            <div className=" col-12">
                <div className="mx-4">
                    <label className="text-muted news-title"> About Club </label>
                    <textarea
                    id='about'
                    name='about'
                    value={data.about}
                    onChange={handleInput}
                    required
                    rows={3}
                    cols='6'
                    className="form-control form-control-lg">

                    </textarea>
                    
                </div>
                
            </div>
            <div className=" col-12">
                <div className="mx-4">
                    
                    <button 
                    // onClick={handleSubmit}
                    // type='submit' 
                    className="btn form-control btn-lg btn-color read-btn mt-2">
					Update
                    </button>
                </div>
                
            </div>
          </div> 
        </form>
        </div>
      </div>
    </div>
  )
}

export default UPdateAbout
